import React from "react";

import { MessageList } from "@components/Message";

export default function MessageIndex() {
  return <MessageList />;
}
